import {http} from '@/http'

// DEF-ADM-019 — Gestión documental dinámica.
// Tipos de documento (mantenedor) y documentos por entidad.
// La ciudad la agrega el interceptor con el header X-City-Id.
export default {
  // ── tipos de documento ──
  listTypes(params) {
    return http.get('/api/v1/document-types', {params})
  },
  saveType(data) {
    return http.post('/api/v1/document-types', data)
  },
  updateType(id, data) {
    return http.put(`/api/v1/document-types/${id}`, data)
  },
  changeTypeStatus(id, status) {
    return http.put(`/api/v1/document-types/${id}/status`, null, {
      params: { status },
    })
  },

  // ── documentos por entidad ──
  // data es un FormData: archivo en 'file' + metadata en campos del formulario.
  upload(data) {
    return http.post('/api/v1/documents', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  listByEntity(entityType, entityId) {
    return http.get('/api/v1/documents', {
      params: { entity_type: entityType, entity_id: entityId },
    })
  },
  fileUrl(id) {
    return http.get(`/api/v1/documents/${id}/file`)
  },
  update(id, data) {
    return http.put(`/api/v1/documents/${id}`, data)
  },
  delete(id) {
    return http.delete(`/api/v1/documents/${id}`)
  },
  compliance(params) {
    return http.get('/api/v1/documents/compliance', {params})
  },
  expiring(days) {
    return http.get('/api/v1/documents/expiring', {params: {days}})
  },
}
